export default __webpack_public_path__ + "static/media/video.ce1c093f.svg";